import React from 'react'

import HomePage from './home-page'

export default function Home() {
    return <HomePage />
}
